import {Component} from "@angular/core";
import {MeasureSearchModel} from "../measure-search.model";
import {MeasureEntityModel} from "../measure-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {MeasureEditPageComponent} from "../measure-edit-page/measure-edit-page.component";

@Component({
    selector: "wbo-measure-search-page",
    templateUrl: "./measure-search-page.component.html",
    providers: [provideSearchModel(MeasureSearchModel), provideEntityModel(MeasureEntityModel)]
})
export class MeasureSearchPageComponent extends AbstractSearchPage {

    constructor(private model: MeasureSearchModel) {
        super();
    }

    prepareInitialFilter(): void {
        if (this.extendedSearchParams && this.extendedSearchParams.searchParams && this.extendedSearchParams.searchParams[MeasureEditPageComponent.RESTRICTED_BASE_MEASURE_ID]) {
            this.model.filter["measureId"] = this.extendedSearchParams.searchParams[MeasureEditPageComponent.RESTRICTED_BASE_MEASURE_ID];
            this.model.setFilterValue("showConvertibleMeasures", true);
            this.model.setFilterValue("base", false);
        }
    }
}
